<template>
  <div>
    <label :for="id"><slot name="date-picker" /></label> <br />
    <el-date-picker
      :id="id"
      type="date"
      class="el-date-picker"
      format="dd/MM/yyyy"
      :placeholder="$getText('MESSAGE_PLACEHOLDER_SELECT_DATE')"
      v-bind="{ ...$props, ...$attrs }"
      v-on="$listeners"
    />
  </div>
</template>

<script>
export default {
  name: 'MessageAdvancedSearchDatePicker',
  data() {
    return {
      id: null,
    };
  },
  mounted() {
    this.id = String(this._uid);
  },
};
</script>

<style lang="scss" scoped>
.el-date-picker.el-date-editor.el-input {
  width: 100%;
}
</style>
